









































import Vue from 'vue';
import {AuthApi} from '@/api/auth-api';
import router from '@/router';
import {RoutsData} from '@/router/routs';

export default Vue.extend({
  name: 'Login',
  data: () => ({
    valid: true,
    login: '',
    passwordRules: [
      (v: string) => !!v || 'Обязательное поле'
    ],
    password: '',
    loginRules: [
      (v: string) => !!v || 'Обязательное поле'
    ]
  }),

  methods: {
    validate() {
      (this.$refs.form as any).validate();
    },
    reset() {
      (this.$refs.form as any).reset();
    },
    submit() {
      this.validate();
      if (this.valid) {
        AuthApi.login({login: this.login, password: this.password})
          .then(res => {
            this.$store.commit('setUser', res.data.user);
            localStorage.setItem('jwt', res.data.access_token);
            router.push({name: RoutsData.DEFAULT.name});
          });
      }
    }
  }
});
